/**
 * Determines if job labor tracking is enabled for the current machine.
 *
 * Job labor tracking requires:
 * - Labor tickets to be enabled in company settings
 * - Machine to be mapped to ERP resources (direct or via machine groups)
 *
 * This enables tracking of labor time against specific jobs/work orders.
 */
import { createSelector } from 'reselect';
import { getIsLaborTicketEnabled } from './getIsLaborTicketEnabled';
import { getIsMachineMappedToErp } from './getIsMachineMappedToErp';

const getIsJobLaborTrackingEnabled = createSelector(
  [getIsLaborTicketEnabled, getIsMachineMappedToErp],
  (laborTicketsEnabled, isMachineMappedToErp) => {
    return laborTicketsEnabled && isMachineMappedToErp;
  }
);

export { getIsJobLaborTrackingEnabled };
